const DesktopSkeleton = () => {
  return (
    <div className="relative w-full px-4">
      {/* ✅ Skeleton for Featured Article */}
      <section className="relative mx-auto w-full animate-pulse overflow-hidden rounded-2xl bg-gray-300 dark:bg-gray-700">
        <div className="h-[200px] w-full rounded-t-2xl sm:h-[350px] md:h-[450px]"></div>
        <div className="p-4 sm:p-6">
          <div className="h-4 w-3/4 rounded bg-gray-400 dark:bg-gray-600"></div>
          <div className="mt-2 h-6 w-full rounded bg-gray-400 dark:bg-gray-600"></div>
          <div className="mt-3 h-4 w-1/2 rounded bg-gray-400 dark:bg-gray-600"></div>
        </div>
      </section>

      {/* ✅ Skeleton for Latest Articles Carousel */}
      <section className="relative mt-6">
        <div className="mb-3 h-6 w-48 rounded bg-gray-400 dark:bg-gray-600"></div>
        <div className="scrollbar-hide flex space-x-4 overflow-x-auto">
          <ul role="list" className="flex space-x-4">
            {[...Array(4)].map((_, index) => (
              <li
                key={index}
                className="w-[180px] flex-shrink-0 sm:w-[220px] md:w-[250px] lg:w-[300px]"
              >
                <div className="relative flex h-full min-h-[280px] animate-pulse flex-col overflow-hidden rounded-2xl bg-gray-300 dark:bg-gray-700 sm:min-h-[320px]">
                  <div className="h-[120px] w-full rounded-t-2xl sm:h-[150px] md:h-[180px]"></div>
                  <div className="flex flex-grow flex-col p-2 sm:p-4">
                    <div className="h-4 w-32 rounded bg-gray-400 dark:bg-gray-600"></div>
                    <div className="mt-2 h-6 w-48 rounded bg-gray-400 dark:bg-gray-600"></div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* ✅ Skeleton for Navigation Buttons */}
        <div className="absolute -left-8 top-1/2 hidden -translate-y-1/2 transform rounded-full bg-gray-400 p-3 dark:bg-gray-600 lg:block"></div>
        <div className="absolute -right-8 top-1/2 hidden -translate-y-1/2 transform rounded-full bg-gray-400 p-3 dark:bg-gray-600 lg:block"></div>
      </section>
    </div>
  );
};

export default DesktopSkeleton;
